import BlogPostData from "./BlogPostData";

export default [
    new BlogPostData(
        "blog-introduction",
        "And the Work is Done",
        "A quick post introducing the blog",
        "2024-06-27",
        "and-the-work-is-done"
    )
];